import React from 'react';
import Highlight from '../../components/Highlight';
import variables from '../../styles/variables.module.scss';

import web1 from '../../assets/frames/polarpumpen-web1@2x-min.jpg';
import web2 from '../../assets/frames/polarpumpen-web2@2x-min.jpg';
import hero from '../../assets/hero/polarpumpen-hero.jpg';
import env1 from '../../assets/envImages/polarpumpen-env1-min.jpg';
import env2 from '../../assets/envImages/polarpumpen-env2-min.jpg';
import footerBanner from '../../assets/envImages/polarpumpen-footerBanner.jpg';

export default {
  path: '/cases/polarpumpen',
  color: variables.polarpumpen,
  hero: { fall: hero },
  env1: { fall: web1 },
  env2: { fall: web2 },
  footerBanner: { fall: footerBanner },
  environments: { env1, env2 },
  isWeb: true,
  quoteData: {
    quote: 'We app built something that was better than what we asked for. They challenged us along the way and proposed better and often-time more efficient solutions for our service. It\'s great to have worked with a partner that not only delivered on time, but also over-delivered.',
    name: 'Daniel Pettersson',
    profession: 'IT Manager, Polarpumpen AB',
  },
  title: 'Solcellsguiden',
  sideHeadingFirst: 'Web application',
  sideHeadingSecond: 'Developed in ReactJS',
  infoTitle: 'What we built',
  infoBody:
  <span>
    We App created a simple to use and responsive web app, where map services was integrated, and an algorithm was built to automatically calculate cost and ROI for solar investments.
    <br />
    <br />
    Consumers can now use the service to navigate to their home using a map service, and easily mark out intended area for solar panels. An algorithm then automatically and accurately calculates the exact area and amount of solar power panels needed. And can subsequently calculate cost and ROI.
    <br />
    <br />
    We App was responsible for both
    {' '}
    <Highlight>frontend</Highlight>
    {' '}
    and
    {' '}
    <Highlight>backend</Highlight>
    {' '}
    of the service.
    <br />
    <br />
    Tech stack used:
    {' '}
    <Highlight>ReactJS, NodeJS, mongoDB, LeafLetJS, CSS, JS, Digital Ocean, REST</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Consumer transparency in solar power',
      body:
  <span>
Polarpumpen is a well-known Swedish brand, working with installation and maintenance of heating, cooling, ventilation and energy solutions for homes and company facilities.
    <br />
    <br />
For their work with Solar power, Polarpumpen sought to develop a solar panel calculator service, that would automate the solar power buying process. And that could be used by consumers to increase transparency and save time, when looking to invest in solar power.
    <br />
    <br />
    The solution would also help automate several steps of a very manual process for the company. A process which previously consisted of measuring roof area, and calculating cost and ROI for the customers, at the physical location.
  </span>,
    },
    1: {
      title: 'Empowering consumers, to power their homes',
      body:
  <span>
    The solution has been a big success in Polarpumpen's effort to both decrease their costs, while also increasing consumer transparency.
    <br />
    <br />
    The solution also had the added benefit of helping increase customer interest and conversion, as consumers can now themselves measure the benefits of solar investment, without the need to book an appointment with the solar power professional. Previously, the professionals would need to measure the roof-top area manually and calculate cost based on the specific considerations, such as materials, inclination and compass direction. A manual, time-consuming and arduous process for both consumer and business. Now automated, and streamlined.
  </span>,
    },
  },
};
